export const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const SET_CARTERA_DETALLE = 'SET_CARTERA_DETALLE';


// WEBPACK FOOTER //
// ./src/reduxstore/actions/action-types.ts